import { useState, useEffect, useCallback } from 'react';
import { useStore } from '../../../../../../hooks';

export const useKnowledgeInitialization = () => {
    const { knowledgeStore } = useStore();
    const [isInitialized, setIsInitialized] = useState(false);
    const [isInitializing, setIsInitializing] = useState(false);
    const [error, setError] = useState(null);

    const initializeStore = useCallback(async () => {
        if (isInitialized || isInitializing) return;

        setIsInitializing(true);
        setError(null);

        try {
            await knowledgeStore.initializeStore();
            setIsInitialized(true);
        } catch (err) {
            console.error('Error initializing knowledge store:', err);
            setError(err.message || 'Failed to initialize knowledge store');
            // Marcar como inicializado para evitar loops infinitos
            setIsInitialized(true);
        } finally {
            setIsInitializing(false);
        }
    }, [knowledgeStore, isInitialized, isInitializing]);

    // Reinicializar si es necesario
    const retryInitialization = useCallback(() => {
        setIsInitialized(false);
        setError(null);
        initializeStore();
    }, [initializeStore]);

    // Reset completo del estado
    const resetInitialization = useCallback(() => {
        setIsInitialized(false);
        setIsInitializing(false);
        setError(null);
        if (knowledgeStore) {
            // Solo resetear si no hay datos cargados
            if (!knowledgeStore.documentStore.hasLoadedData()) {
                knowledgeStore.documentStore.resetState();
            } else {
                console.log('Documents already loaded, skipping reset in hook');
                // Si ya hay datos, marcar como inicializado
                setIsInitialized(true);
            }
        }
    }, [knowledgeStore]);

    // Inicializar automáticamente cuando se monta el componente
    useEffect(() => {
        if (knowledgeStore && !isInitialized && !isInitializing) {
            // Si ya hay datos, marcar como inicializado inmediatamente
            if (knowledgeStore.documentStore.hasLoadedData()) {
                console.log('Store already has data, setting initialized to true');
                setIsInitialized(true);
                return;
            }
            
            initializeStore();
        }
    }, [knowledgeStore, isInitialized, isInitializing, initializeStore]);

    return {
        isInitialized,
        isInitializing,
        error,
        initializeStore,
        retryInitialization,
        resetInitialization
    };
};
